<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-actiuni-cerere">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-regular fa-pen-to-square"></i>
                                <span>&nbsp;Actualizare cerere</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="col p-2 d-flex justify-content-start">
                        <div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onActionChange($event)" value="status">
                                <mat-button-toggle
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-status')"
                                    value="status">Status</mat-button-toggle>
                                <mat-button-toggle
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.escaladare')"
                                    value="escaladare">Repartizare</mat-button-toggle>
                                <mat-button-toggle
                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-prioritate')"
                                    value="prioritate">Prioritate</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" *ngIf="selectedActionToggle == 'status'">
                            <div
                                *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-status')">
                                <form [formGroup]="sendUpdateStatusForm" (ngSubmit)="submitUpdateStatusMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="current_status">
                                                    <mat-option *ngFor="let status of requestStatuses"
                                                        [value]="status.id">
                                                        {{ status.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați un status</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="message"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button [disabled]="sendUpdateStatusForm.invalid"
                                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-status')"
                                                    class="btn btn-light upload-btn m-3" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col" *ngIf="selectedActionToggle == 'prioritate'">
                            <div
                                *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-prioritate')">
                                <form [formGroup]="sendUpdatePriorityForm" (ngSubmit)="submitUpdatePriorityMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Prioritate</mat-label>
                                                <mat-select formControlName="id_cerere_priority">
                                                    <mat-option *ngFor="let row of requestPriorities" [value]="row.id">
                                                        {{ row.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați o prioritate</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="message"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button [disabled]="sendUpdatePriorityForm.invalid"
                                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.actualizare-prioritate')"
                                                    class="btn btn-light upload-btn m-3" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col" *ngIf="selectedActionToggle == 'escaladare'">
                            <div
                                *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.escaladare')">
                                <form [formGroup]="sendUpdateAssigneeForm" (ngSubmit)="submitUpdateAssigneeMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field appearance="fill" class="w-100">
                                                <mat-label>Direcție/Instituție</mat-label>
                                                <mat-select formControlName="directie_id"
                                                    (openedChange)="onDirectieClosed()"
                                                    (selectionChange)="onDirectieChange($event.value)">
                                                    <mat-form-field class="px-2 sticky-input">
                                                        <input matInput [formControl]="directiiControl"
                                                            (keydown)="$event.stopPropagation()"
                                                            (click)="$event.stopPropagation()" />
                                                    </mat-form-field>

                                                    <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                                        <span>Nu au fost găsite direcții</span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let directie of filteredDirectii"
                                                        [value]="directie.id">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field appearance="fill" class="w-100">
                                                <mat-label>Compartiment/Birou/Serviciu</mat-label>
                                                <mat-select formControlName="compartiment_id"
                                                    (openedChange)="onDirectieCompartimentClosed()" (selectionChange)="
                                                    onDirectieCompartimentChange($event.value)
                                                ">
                                                    <mat-form-field class="px-2 sticky-input">
                                                        <input matInput [formControl]="compartimenteControl"
                                                            (keydown)="$event.stopPropagation()"
                                                            (click)="$event.stopPropagation()" />
                                                    </mat-form-field>

                                                    <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                                        <span>Nu au fost găsite compartimente</span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of filteredCompartimente"
                                                        [value]="compartiment.id">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field appearance="fill" class="w-100">
                                                <mat-label>Operator</mat-label>
                                                <mat-select formControlName="user_id"
                                                    (openedChange)="onUsersActiveClosed()">
                                                    <mat-form-field class="px-2 sticky-input">
                                                        <input matInput [formControl]="usersControl"
                                                            (keydown)="$event.stopPropagation()"
                                                            (click)="$event.stopPropagation()" />
                                                    </mat-form-field>

                                                    <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                                        <span>Nu au fost găsiți operatori</span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                                        {{ user.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați un operator</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="message"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button [disabled]="sendUpdateAssigneeForm.invalid"
                                                    *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.cerere-view.escaladare')"
                                                    class="btn btn-light upload-btn m-3" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-spinner position-fixed" *ngIf="isLoading">
                    <div class="spinner position-absolute top-50 start-50 translate-middle">
                        <mat-spinner></mat-spinner>
                        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>